<template>
  <div class="mb-3">
    <label class="d-block">
      {{ label }} <span v-if="required" class="text-danger">*</span>
    </label>
    <vee-field
      :name="name"
      :rules="validationRules"
      v-slot="{ field, meta, errorMessage }"
    >
      <div>
        <div v-for="option in options" :key="option.value" class="form-check">
          <input
            type="radio"
            :id="`${id}_${option.value}`"
            :name="name"
            :value="option.value"
            v-model="field.value"
            :class="[
              'form-check-input',
              { 'is-invalid': meta.touched && !meta.valid },
            ]"
            @change="field.onChange"
          />
          <label class="form-check-label" :for="`${id}_${option.value}`">
            {{ option.key }}
          </label>
        </div>
      </div>
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />
  </div>
</template>

<script setup>
defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array,
    default: () => [],
  },
  fieldName: {
    type: String,
    default: "",
  },
  validationRules: {
    type: [Function, Array, String, Object],
    default: () => () => true,
  },
});
</script>
